import { connect } from 'react-redux';
import _get from 'lodash/get';
import { Global } from 'state/Global';
import { DeviceMonitoringStatus, RoomSystem } from 'typings/types';
import { featureSelectors } from '@lifesize/nucleus';
import {
  FEATURE_FLAG_ROOM_SYSTEM_REBOOT,
  FEATURE_FLAG_ROOM_SYSTEM_RESET,
  FEATURE_FLAG_ROOM_SYSTEM_UPGRADE_MANAGEMENT
} from 'constants/featureFlags';
import MaintenanceTabComponent from 'components/RoomSystem/MaintenanceTab/MaintenanceTabComponent';
import { MONITORING_LINE_ITEMS } from 'constants/roomSystemConstants';
import { isRoomSystemOffline, isRebootSupported, isResetSupported } from 'utils/roomSystemUtils';
import { actions as ModalActions } from 'actions/modalActions';
import { ModalTypes } from 'constants/modalConstants';

interface Props {
  hasMonitoringData: boolean;
  deviceMonitoring: DeviceMonitoringStatus;
  roomSystem: RoomSystem;
}
const mapStateToProps = (state: Global, ownProps: Props) => ({
  showReboot: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_ROOM_SYSTEM_REBOOT) && isRebootSupported(ownProps.roomSystem),
  canReboot: !isRoomSystemOffline(ownProps.roomSystem),
  showReset: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_ROOM_SYSTEM_RESET) && isResetSupported(ownProps.roomSystem),
  canReset: !isRoomSystemOffline(ownProps.roomSystem),
  canPerformUpgradeManagement: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_ROOM_SYSTEM_UPGRADE_MANAGEMENT),
  monitoringStatusUpdatedTimestamp: ownProps.hasMonitoringData
    ? MONITORING_LINE_ITEMS.reduce((acc, cur) => {
      const timestamp = _get(ownProps.deviceMonitoring, `metrics[${cur}].timestamp`, 0);
      return timestamp > acc ? timestamp : acc;
    },
                                   0
    ) : null,
  errorCount: ownProps.hasMonitoringData
    ? MONITORING_LINE_ITEMS.reduce(
      (acc, cur) => {
        if (_get(ownProps.deviceMonitoring, `metrics[${cur}].value`) === false) {
          return acc + 1;
        }
        return acc;
      },
      0
    ) : 0
});

const mapDispatchToProps = (dispatch: Function, ownProps: Props) => ({
  reboot: () => {
    dispatch(
      ModalActions.openModal({
        modalType: ModalTypes.REBOOT_DEVICE,
        payload: { serialNumber: _get(ownProps, 'roomSystem.serialNumber') }
      }),
    );
  },
  reset: () => {
    dispatch(
      ModalActions.openModal({
        modalType: ModalTypes.RESET_DEVICE,
        payload: { serialNumber: _get(ownProps, 'roomSystem.serialNumber') }
      }),
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceTabComponent);
